import { asyncActionType } from 'util/methods';

const InspectionTypes = {
  INSPECTION_JOB_DETAIL_INIT: 'INSPECTION_JOB_DETAIL_INIT',

  INSPECTION_JOB_DETAIL_INVOICE_INIT: 'INSPECTION_JOB_DETAIL_INVOICE_INIT',

  INSPECTION_JOB_INVOICE_TOGGLE: 'INSPECTION_JOB_INVOICE_TOGGLE',
  INSPECTION_JOB_INVOICE_PREV_STEP: 'INSPECTION_JOB_INVOICE_PREV_STEP',
  INSPECTION_JOB_INVOICE_NEXT_STEP: 'INSPECTION_JOB_INVOICE_NEXT_STEP',

  // ******** Fetch REPORT ********

  INSPECTION_REPORT_FETCH_BEGIN: 'INSPECTION_REPORT_FETCH_BEGIN',
  INSPECTION_REPORT_FETCH_SUCCESS: 'INSPECTION_REPORT_FETCH_SUCCESS',
  INSPECTION_REPORT_FETCH_FAIL: 'INSPECTION_REPORT_FETCH_FAIL',

  //  ******* Invoice POST *******

  INSPECTION_JOB_INVOICE_SUBMIT_BEGIN: 'INSPECTION_JOB_INVOICE_SUBMIT_BEGIN',
  INSPECTION_JOB_INVOICE_SUBMIT_SUCCESS: 'INSPECTION_JOB_INVOICE_SUBMIT_SUCCESS',
  INSPECTION_JOB_INVOICE_SUBMIT_FAIL: 'INSPECTION_JOB_INVOICE_SUBMIT_FAIL',

  INSPECTION_JOB_INVOICE_UPLOAD_SUCCESS: 'INSPECTION_JOB_INVOICE_UPLOAD_SUCCESS',

  INSPECTION_JOB_DETAIL_RESET: 'INSPECTION_JOB_DETAIL_RESET',

  //  ******* New Invoice *******

  INSPECTION_JOB_INVOICE_GET_LIST: asyncActionType('INSPECTION_JOB_INVOICE_GET_LIST'),
  INSPECTION_JOB_INVOICE_CREATE: asyncActionType('INSPECTION_JOB_INVOICE_CREATE'),
  INSPECTION_JOB_INVOICE_UPDATE: asyncActionType('INSPECTION_JOB_INVOICE_UPDATE'),
  INSPECTION_JOB_INVOICE_DELETE: asyncActionType('INSPECTION_JOB_INVOICE_DELETE'),
  INSPECTION_JOB_INVOICE_DOWNLOAD_LIST: asyncActionType('INSPECTION_JOB_INVOICE_DOWNLOAD_LIST'),

  //  ******* New Report *******
  INSPECTION_JOB_REPORT_GET_LIST: asyncActionType('INSPECTION_JOB_REPORT_GET_LIST'),
  INSPECTION_JOB_REPORT_GET_DETAIL: asyncActionType('INSPECTION_JOB_REPORT_GET_DETAIL'),
  INSPECTION_JOB_REPORT_CREATE: asyncActionType('INSPECTION_JOB_REPORT_CREATE'),
  INSPECTION_JOB_REPORT_DUPLICATE: asyncActionType('INSPECTION_JOB_REPORT_DUPLICATE'),
  INSPECTION_JOB_REPORT_UPDATE: asyncActionType('INSPECTION_JOB_REPORT_UPDATE'),
  INSPECTION_JOB_REPORT_DELETE: asyncActionType('INSPECTION_JOB_REPORT_DELETE'),
  INSPECTION_JOB_REPORT_DOWNLOAD: asyncActionType('INSPECTION_JOB_REPORT_DOWNLOAD'),

  INSPECTION_JOB_REPORT_PO_ITEM_UPDATE: asyncActionType('INSPECTION_JOB_REPORT_PO_ITEM_UPDATE'),
  INSPECTION_JOB_REPORT_PO_ITEM_DELETE: asyncActionType('INSPECTION_JOB_REPORT_PO_ITEM_DELETE'),

  INSPECTION_JOB_REPORT_PO_ITEM_DEFECT_ITEM_DELETE: asyncActionType(
    'INSPECTION_JOB_REPORT_PO_ITEM_DEFECT_ITEM_DELETE'
  ),

  // ********** Inspection Attachment Actions **************
  INSPECTION_GET_ATTACHMENTS: asyncActionType('INSPECTION_GET_ATTACHMENTS'),
  INSPECTION_DOWNLOAD_ATTACHMENTS: asyncActionType('INSPECTION_DOWNLOAD_ATTACHMENTS'),
  INSPECTION_ADD_ATTACHMENT: asyncActionType('INSPECTION_ADD_ATTACHMENT'),
  INSPECTION_DELETE_ATTACHMENT: asyncActionType('INSPECTION_DELETE_ATTACHMENT'),
};

export default InspectionTypes;
